import React from 'react';
import { Switch } from 'react-router-dom';
import { BundleRoute } from '@saucelabs/sl-component-router';
import { LoginRequiredContainer } from '@saucelabs/sl-container-authentication';
import dynamic from '@redux-dynostore/react-redux';
import { attachReducer } from '@redux-dynostore/core';

import manualReducer from './reducers';

const desktopImport = () => import(/* webpackChunkName: "manual-desktop" */ './containers/sessionVirtual/DesktopManualContainer');
const mobileImport = () => import(/* webpackChunkName: "manual-mobile" */ './components/MobileManualSession');

const ManualFullscreenRoutes = () => (
  <LoginRequiredContainer>
    <Switch>
      <BundleRoute
        load={mobileImport}
        path="/live/mobile/dataCenters/:dataCenterId/devices/:deviceId"
      />
      <BundleRoute
        load={desktopImport}
        path="/live/:taskId"
      />
    </Switch>
  </LoginRequiredContainer>
);

export default dynamic(
  'apps.manual', attachReducer(manualReducer),
)(ManualFullscreenRoutes);
